import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BioDimensions } from './../TabsContent/BioTabs';
import { BioUniDimensions } from './../TabsContent/BioUniTabs';
import { ClasicPlusDimensions } from './../TabsContent/ClassicPlusTabs';
import { DuoPelletDimensions } from './../TabsContent/DuoPelletTabs';
import { DuoPelletNDimensions } from './../TabsContent/DuoPelletNTabs';
import { DuoUniPlusDimensions } from './../TabsContent/DuoUniPlusTabs';
import { DuoUniPelletDimensions } from './../TabsContent/DuoUniPelletTabs';
import { DuoUniPelletPlusDimensions } from './../TabsContent/DuoUniPelletPlusTabs';
import { MaxDimensions } from './../TabsContent/MaxTabs';
import { MegaDimensions } from './../TabsContent/MegaTabs';
import { TrioDimensions } from './../TabsContent/TrioTabs';
import { TrioPelletDimensions } from '../TabsContent/TrioPelletTabs';
import { TrioUniPelletDimensions } from '../TabsContent/TrioUniPelletTabs';
import { TrioUniPelletPlusDimensions } from '../TabsContent/TrioUniPelletPlusTabs';
import { TrioUniPlusDimensions } from '../TabsContent/TrioUniPlusTabs';
import { TurboDimensions } from '../TabsContent/TurboTabs';
import { AltepPelletsDimensions } from '../TabsContent/AltepPelletsTabs';
import { AgroDimensions } from '../TabsContent/AgroTabs';

const Dimensions = (props) => {
  switch (props.productId) {
    case 1:
      return <BioDimensions />
    case 2:
      return <BioUniDimensions />
    case 4:
      return <ClasicPlusDimensions />
    case 5:
      return <DuoPelletDimensions />
    case 6:
      return <DuoPelletNDimensions />
    case 7:
      return <DuoUniPlusDimensions />
    case 8:
      return <DuoUniPelletDimensions />
    case 9:
      return <DuoUniPelletPlusDimensions />
    case 10:
      return <MaxDimensions />
    case 11:
      return <MegaDimensions />
    case 12:
      return <TrioDimensions />
    case 16:
      return <TrioPelletDimensions />
    case 17:
      return <TrioUniPelletDimensions />
    case 18:
      return <TrioUniPelletPlusDimensions />
    case 19:
      return <TrioUniPlusDimensions />
    case 20:
      return <TurboDimensions />
    case 21:
      return <AltepPelletsDimensions />
    case 22:
      return <AgroDimensions />
    default:
      return <></>
  }
};

export default Dimensions;

